import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { getData } from "../API";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import * as XLSX from 'xlsx';

function ZoneWiseReport() {
  const [allZoneData, setAllZoneData] = useState([]);
  const [filters, setFilters] = useState({
    fromDate: "2024-07-10", // Fixed start date
    toDate: "",
    zoneId: "",
  });
  const [filteredData, setFilteredData] = useState([]);
  const [pinnedBottomRowData, setPinnedBottomRowData] = useState([]);
  const rowHeight = 45;
  const [tableHeight, setTableHeight] = useState(364);
 const [isLoading, setIsLoading] = useState(true);
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const getZoneType = async () => {
    try {
      const res = await getData("SurveyMasters/UCCZoneMasters");
      setAllZoneData(res.data);
    } catch (error) {
      console.error("Error fetching zone data:", error);
      setAllZoneData([]);
    }
  };

  const fetchZoneWiseData = async () => {
    setIsLoading(true);
    let ZoneId = filters.zoneId;
    let FromDate = filters.fromDate;
    let ToDate = filters.toDate;
    try {
      let res = await getData(
        `SurveyMasters/GetZoneWiseFilterData?FromDate=${FromDate}&ToDate=${ToDate}&zoneId=${ZoneId}`
      );

      // Calculate totals
      const totalFormsCompleted = res.data.reduce((acc, item) => acc + item.totalFormsCompleted, 0);

      // Create total row data
      const totalRow = {
        sNo: '',
        zoneName: "Total",
        totalFormsCompleted: totalFormsCompleted,
        isTotalRow: true, // Add a flag to identify the total row
      };

      // Set data and footer row
      setFilteredData(res.data);

      // Set dynamic table height based on the number of rows
      // setTableHeight(res.data.length * rowHeight + 45);

      setPinnedBottomRowData([totalRow]);
    } catch (error) {
      console.error("Error fetching zone wise data:", error);
    }finally {
    setIsLoading(false); // Done loading
  }
  };

  useEffect(() => {
    getZoneType();
    fetchZoneWiseData();
  }, []); // Fetch data initially when the component mounts

  const handleSearch = () => {
    fetchZoneWiseData();
  };

  const columnDefs = [
    {
      headerName: "S.No",
      field: "sNo",
      valueGetter: (params) => {
        if (params.node.rowPinned) {
          return ''; // Return empty string for footer row
        }
        return params.node.rowIndex + 1;
      },
      headerClass: "grid-header",
      cellClassRules: {
        'total-row': (params) => params.data && params.data.isTotalRow,
      },
    },
    {
      field: "zoneName",
      headerName: "Zone",
      headerClass: "grid-header",
      cellClassRules: {
        'total-row': (params) => params.data && params.data.isTotalRow,
      },
    },
    {
      field: "totalFormsCompleted",
      headerName: "Count",
      headerClass: "grid-header",
      cellClassRules: {
        'total-row': (params) => params.data && params.data.isTotalRow,
      },
    },
  ];

  const defaultColDef = {
    sortable: true,
    resizable: true,
    flex: 1,
  };

  const downloadExcel = () => {
    const tableHeaders = ["S.No", "Zone", "Count"];
    
    // Include the total row in the tableData
    const tableData = filteredData.map((item, index) => ({
      "S.No": index + 1,
      "Zone": item.zoneName,
      "Count": item.totalFormsCompleted,
    }));
    
    // Add the total row to tableData
    if (pinnedBottomRowData.length > 0) {
      const totalRow = pinnedBottomRowData[0];
      tableData.push({
        "S.No": "",
        "Zone": totalRow.zoneName, 
        "Count": totalRow.totalFormsCompleted,
      });
    }
  
    const worksheet = XLSX.utils.json_to_sheet(tableData);
    XLSX.utils.sheet_add_aoa(worksheet, [tableHeaders], { origin: 'A1' });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Reports Data");
    XLSX.writeFile(workbook, "ZoneWiseReportsData.xlsx");
  };

  return (
    <main className="page-content content">
      <div className="container-fluid p-0">
        <div className="row align-items-end">
          <div className="col-md-3 mb-3">
            <div className="form-group">
              <label>Zone</label>
              <select
                type="select"
                className="form-select"
                name="zoneId"
                onChange={handleFilterChange}
                style={{
                  backgroundColor: "#D9D9D9",
                  boxShadow:
                    "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                }}
                value={filters.zoneId}
              >
                <option value="">Select</option>
                {allZoneData.map((zone) => (
                  <option key={zone.uccZoneId} value={zone.uccZoneId}>
                    {zone.zoneName}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="col-md-3 mb-3">
            <div className="form-group">
              <label>From Date</label>
              <input
                style={{
                  boxShadow:
                    "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                }}
                type="date"
                className="form-control inputdate"
                name="fromDate"
                value={filters.fromDate}
                onChange={handleFilterChange}
                max={new Date().toISOString().split("T")[0]}
              />
            </div>
          </div>
          <div className="col-md-3 mb-3">
            <div className="form-group">
              <label>To Date</label>
              <input
                style={{
                  background: "#D9D9D9",
                  boxShadow:
                    "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
                }}
                type="date"
                className="form-control inputdate"
                name="toDate"
                value={filters.toDate}
                onChange={handleFilterChange}
                max={new Date().toISOString().split("T")[0]}
              />
            </div>
          </div>
          <div className="col-md-3 mb-3 text-start">
            <button
              className="btn px-4"
              onClick={handleSearch}
              style={{
                background: "#a7252ced",
                border: "none",
                color: "white",
                boxShadow:
                  "0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)",
              }}
            >
              SEARCH
            </button>
          </div>
        </div>

        {/* Excel Download Button Moved to Top */}
        <div className="row mb-3">
          <div className="col-md-12 text-start">
            <button className='btn' onClick={downloadExcel} style={{ background: "#9CA3AF", color: "white", boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)' }}>
              Excel <i className="fa-solid fa-download ms-1"></i>
            </button>
          </div>
        </div>

        <div className="row mt-3" style={{ marginBottom: "107px" }}>
          <div className="col-md-12">
              <div style={{ position: 'relative' }}>
              {isLoading && (
                <div className="loader-overlay">
                 <div className="spinner" />
                </div>
              )}
            <div className="table-responsive">
              <div 
                className="ag-theme-alpine"
                // style={{ height: "100%", width: "100%" }}
              >
                <AgGridReact
                  rowData={isLoading ? [] : filteredData}
                  columnDefs={columnDefs}
                  defaultColDef={defaultColDef}
                  domLayout="autoHeight"
                  pinnedBottomRowData={pinnedBottomRowData}
                   overlayNoRowsTemplate={
                  !isLoading
                    ? '<span class="ag-overlay-loading-center">No data available</span>'
                    : undefined // ✅ Don't render overlay at all when loading
                }
                />
              </div>
            </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
}

export default ZoneWiseReport;
